export enum TimeStep{
    MONTH = "MONTH",
    YEAR = "YEAR",
    WEEK = "WEEK",
}
